export enum ProjetoStatus {
  EM_PREPARACAO = 'EM_PREPARACAO',
  ATIVO = 'ATIVO',
  ENCERRADO = 'ENCERRADO',
  CANCELADO = 'CANCELADO'
}
